import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HomeworksService } from '../../services/homeworks.service';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { Homework } from '../../models/homework';

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
  providers: [DatePipe]
})
export class DateSelectorComponent extends ComponentBase implements OnInit {

  constructor(private datePipe: DatePipe
    , private homeworksService: HomeworksService) {
    super();
    this.currentDate.setDate(1);
  }

  @Output() selectedDate = new EventEmitter<Date>();
  currentDate: Date = new Date();
  currentMonth: string;
  currentYear: string;
  daysInCurrentMonth: Array<Date> = [];
  weeks: Date[][];
  dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  daysInFirstWeek: number;
  homeworks: Array<Homework> = [];

  ngOnInit() {
    this.generateCalendar();
  }

  generateCalendar() {
    let subscription = this.homeworksService.GetHomeworksByDateRange(this.currentDate, new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0))
      .subscribe(res => {
        this.homeworks = res;
      });
    this.currentMonth = this.datePipe.transform(this.currentDate, 'MMMM');
    this.currentYear = this.datePipe.transform(this.currentDate, 'yyyy');
    this.daysInCurrentMonth = this.getDaysInMonth(this.currentDate.getMonth(), this.currentDate.getFullYear());
    //since week starts on monday
    this.daysInFirstWeek = this.currentDate.getDay() ? (7 - this.currentDate.getDay() + 1) : 1;
    var weeks = [];
    if (this.daysInFirstWeek < 7) {
      weeks.push([]);
      for (var i = 1; i <= 7; i++) {
        if (weeks[0].length < 7 - this.daysInFirstWeek) {
          weeks[0].push(null);
        } else {
          weeks[0].push(this.daysInCurrentMonth.splice(0, 1)[0]);
        }
      }
    }
    while (this.daysInCurrentMonth.length > 0) {
      weeks.push(this.daysInCurrentMonth.splice(0, 7));
    }
    for (i = weeks[weeks.length - 1].length; i < 7; i++) {
      weeks[weeks.length - 1].push(null);
    }
    this.weeks = weeks;
    this.addSubscription(subscription);
  }

  getDaysInMonth(month, year): Array<Date> {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  prevMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1)
    this.generateCalendar();
  }

  nextMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1)
    this.generateCalendar();
  }

  homeworkAssigned(day: Date) {
    if (day) {
      let date1 = day.toISOString().split('T')[0];
      let date = this.datePipe.transform(day, "yyyy-MM-dd")
      let hw = this.homeworks.find(o => o.target_date.split('T')[0] == date);
      if (hw) {
        return "active";
      }
    }
  }

  dayClicked(day: Date) {
    this.selectedDate.emit(day);
  }
}
